import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#1B2E4B] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo & Baseline */}
          <div>
            <div className="mb-4">
              <span className="font-heading text-2xl font-black tracking-tight">
                Bati Rui
              </span>
              <span className="block text-xs font-medium text-[#C0392B] tracking-widest uppercase mt-1">
                Tous corps d'état
              </span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Entreprise artisanale de rénovation à Paris depuis 2011.
              Un seul interlocuteur pour tous vos travaux.
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">
              Liens rapides
            </h3>
            <ul className="space-y-2">
              {[
                { label: "Accueil", to: "/" },
                { label: "Services", to: "/services" },
                { label: "Réalisations", to: "/realisations" },
                { label: "Contact", to: "/contact" },
                { label: "Mentions légales", to: "/mentions-legales" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.to.replace("/", "") || "home"}`}
                    className="text-white/70 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Coordonnées */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">
              Coordonnées
            </h3>
            <div className="space-y-3 text-sm text-white/70">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 flex-shrink-0 text-[#C0392B]" />
                <span>45 rue de l'Espérance<br />75013 Paris</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="flex-shrink-0 text-[#C0392B]" />
                <a href="tel:+33632255275" className="hover:text-white transition-colors">
                  06 32 25 52 75
                </a>
              </div>
              <p className="pt-1">Zone d'intervention : Paris & Ile-de-France</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <span>&copy; 2025 Bati Rui — SIREN 529 399 586</span>
          <Link
            to="/mentions-legales"
            className="hover:text-white/80 transition-colors"
          >
            Mentions légales
          </Link>
        </div>
      </div>
    </footer>
  );
}
